"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xssTransformOut = exports.xssTransformIn = void 0;

var _xssProtect = require("../constants/xss-protect");

var toCamelCase = function toCamelCase(string) {
  return string.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
};

var toKabob = function toKabob(string) {
  return string.replace(/([a-z][A-Z])/g, function (g) {
    return g[0] + "-" + g[1].toLowerCase();
  });
};

var dummyNode = document.createElement('div'); // The use of SET here is OK because we only use the `has` method
// which has the browser support we need
// eslint-disable-next-line no-restricted-globals

var attributeSet = new Set(_xssProtect.ATTRIBUTE_WHITE_LIST);

var xssTransformIn = function xssTransformIn(body) {
  var retainAttribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var nodes = Array.from(body.querySelectorAll('*'));
  var dataRegex = /data/;
  nodes.forEach(function (node) {
    var attrs = node.attributes;

    for (var i = 0; i < attrs.length; i++) {
      var attrName = attrs[i].name;
      var attrValue = attrs[i].value;

      if (!attributeSet.has(attrName) && !dataRegex.test(attrName)) {
        try {
          dummyNode.setAttribute(attrName, attrValue);
          dummyNode.removeAttribute(attrName);
        } catch (e) {
          console.info(_xssProtect.HS_PROTECT + ": " + attrName + " is not a valid attribute, ignoring.");
          console.error(e);
          continue;
        }

        try {
          if (retainAttribute) {
            node.dataset["" + _xssProtect.HS_PROTECT + toCamelCase(attrName)] = attrValue;
          }

          node.removeAttribute(attrName);
        } catch (e) {
          console.info(_xssProtect.HS_PROTECT + ": Failed to set " + attrName + " on element dataset");
          console.error(e);
        }
      }
    }
  });
};

exports.xssTransformIn = xssTransformIn;

var xssTransformOut = function xssTransformOut(body) {
  var nodes = Array.from(body.querySelectorAll('*'));
  nodes.forEach(function (node) {
    var dataset = node.dataset;
    Object.keys(dataset).forEach(function (dataKey) {
      if (dataKey.startsWith(_xssProtect.HS_PROTECT)) {
        node.setAttribute(toKabob(dataKey.replace(_xssProtect.HS_PROTECT, '')), dataset[dataKey]);
        delete dataset[dataKey];
      }
    });
  });
};

exports.xssTransformOut = xssTransformOut;